'use client'

import { IPlant } from "@/models/types/plant";
import { UseFormReturnType } from "@mantine/form";
import { useStateStore } from "@/context/stateStore";
import FirstSection from "./plantFields/firstSection";
import { PlantCareSchedule, PlantDescription, PlantFertilizerType, PlantNPKRatio, PlantSeason, PlantSeasonToAvoid, PlantSoilType, PlantSunlightHours, PlantSunlightRequirement, PlantTimeToGrow, PlantWaterFrequency } from "./plantFields/plantFieldsComps";

export type PlantFormType = UseFormReturnType<{ plant: IPlant }, (values: { plant: IPlant }) => { plant: IPlant }>;

export default function PlantFields({ plantForm, plant }: { plantForm: PlantFormType, plant: IPlant }) {

    const widthQuery = useStateStore(state => state.widthQuery);
    const height = useStateStore(state => state.heightQuery);

    return (
            <section className="grid grid-cols-1 xl:grid-cols-[minmax(260px,360px)_1fr] gap-4 w-full h-content p-2 md:p-4 bg-emerald-950/10 rounded-md border border-emerald-900/10">

                <FirstSection plantForm={plantForm} plant={plant} widthQuery={widthQuery} heightQuery={height} />

                <div className="grid grid-cols-1 gap-4">
                    <section className="rounded-md border border-gray-200 bg-white p-4 shadow-sm">
                        <div className="mb-3 flex items-center justify-between gap-3 border-b border-gray-100 pb-2">
                            <h2 className="text-sm font-semibold text-emerald-950">Care Schedule</h2>
                            <span className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-medium text-emerald-900">
                                {plantForm.getValues().plant.careSchedule?.reminderEnabled ? 'Reminders on' : 'Reminders off'}
                            </span>
                        </div>
                        <PlantCareSchedule plantForm={plantForm} heightQuery={height} />
                    </section>

                    <section className="rounded-md border border-gray-200 bg-white p-4 shadow-sm">
                        <h2 className="mb-3 border-b border-gray-100 pb-2 text-sm font-semibold text-emerald-950">Growing Conditions</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <PlantSeason plantForm={plantForm} heightQuery={height} />
                            <PlantSeasonToAvoid plantForm={plantForm} heightQuery={height} />
                            <PlantTimeToGrow plantForm={plantForm} heightQuery={height} />
                            <PlantWaterFrequency plantForm={plantForm} heightQuery={height} />
                            <PlantSunlightRequirement plantForm={plantForm} heightQuery={height} />
                            <PlantSunlightHours plantForm={plantForm} heightQuery={height} />
                        </div>
                    </section>

                    <section className="rounded-md border border-gray-200 bg-white p-4 shadow-sm">
                        <h2 className="mb-3 border-b border-gray-100 pb-2 text-sm font-semibold text-emerald-950">Soil & Feeding</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <PlantSoilType plantForm={plantForm} heightQuery={height} />
                            <PlantFertilizerType plantForm={plantForm} heightQuery={height} />
                            <PlantNPKRatio plantForm={plantForm} heightQuery={height} />
                        </div>
                    </section>

                    <section className="rounded-md border border-gray-200 bg-white p-4 shadow-sm">
                        <PlantDescription plantForm={plantForm} />
                    </section>
                </div>
            </section>
    )
}
